import type { AxiosInstance, AxiosRequestConfig } from 'axios'

import type { Media } from '@/types'
import { MediaOrigin } from '@/types'

import BaseService from './BaseService'
import type { MediaFilter } from './MediaService.types'

export default class MediaService extends BaseService<
  Media,
  Partial<Media>,
  MediaFilter
> {
  constructor(client: AxiosInstance) {
    super(client, 'media')
  }

  async upload(payload: FormData, config?: AxiosRequestConfig): Promise<Media> {
    const { data } = await this.client.post<Media>(
      `/${this.entity}`,
      payload,
      config
    )
    return data
  }

  async findImages(
    payload: { query: string; start: number },
    config?: AxiosRequestConfig
  ) {
    const { data } = await this.client.post(
      `/${this.entity}/find`,
      payload,
      config
    )
    return data
  }

  async addExternal(payload: { src: string }[]) {
    const { data } = await this.client.post(`/${this.entity}/external`, payload)
    return data
  }

  protected s(filter: MediaFilter, params: Record<string, unknown>) {
    params.origin = { $or: { $isnull: true, $eq: MediaOrigin.CONTENT_TOOL } }

    if (filter.type !== undefined) {
      params.type = { $eq: filter.type }
    }
  }
}
